import React, {useEffect, useState} from 'react';
import {Card} from "primereact/card";
import {Dropdown} from "primereact/dropdown";
import {webInfo} from "../../utils/webInfo";
import {depots, getDivisionWiseUrl} from "../../utils/helper";
import ErrorPresentor from "../../ErrorPresentor/ErrorPresentor";
import useApi from "../../hooks/useApi";
import HumanTable from "../Categories/DivisionWiseDataTable/HumanTable";
import AnimalTable from "../Categories/DivisionWiseDataTable/AnimalTable";
import HerbalTable from "../Categories/DivisionWiseDataTable/HerbalTable";
import CropTable from "../Categories/DivisionWiseDataTable/CropTable";
import AgroTable from "../Categories/DivisionWiseDataTable/AgroTable";
import GardeniaTable from "../Categories/DivisionWiseDataTable/GardeniaTable";
import PetTable from "../Categories/DivisionWiseDataTable/PetTable";
import TableSkeleton from "../../Loader/Loader";
import {Button} from "primereact/button";
import NewCategoryModal from "./NewCategoryModal";


const Categories = () => {
    const [selectedDepot, setSelectedDepot] = useState({name: 'Chemist Laboratories', code: '8'});
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const {get, loading, error} = useApi<any>();
    const url = `${webInfo.baseUrl}/api/admin/products-${getDivisionWiseUrl(selectedDepot.code)?.url}-category?page=${page}&per_page=${perPage}`
    const [categories,setCategories] = useState([]);
    const [newCategoryModal, setNewCategoryModal] = useState(false);
    const [update,setUpdate] = useState(false);


    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res: any = await get(url);
                setCategories(res.data.data);
                setTotal(res.page_count.total);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchCategories();
        // eslint-disable-next-line
    }, [page, perPage, selectedDepot.code,update]);

    if (error) {
        return <ErrorPresentor error={error}/>
    }


    const onPageChange = (event: any) => {
        setPage(event.page + 1);
    }



    const dataTable =
        Number(selectedDepot.code) === 8 ?
            <HumanTable products={categories} total={total} selectedDepot={selectedDepot} onPageChange={onPageChange} page={page} perPage={perPage} update={update} setUpdate={setUpdate}/> :
            Number(selectedDepot.code) === 9 ? <AnimalTable products={categories} total={total} selectedDepot={selectedDepot} onPageChange={onPageChange} page={page} perPage={perPage} update={update} setUpdate={setUpdate}/> :
                Number(selectedDepot.code) === 10 ? <HerbalTable products={categories} total={total} selectedDepot={selectedDepot} onPageChange={onPageChange} page={page} perPage={perPage} update={update} setUpdate={setUpdate}/> :
                    Number(selectedDepot.code) === 11 ? <CropTable products={categories} total={total} selectedDepot={selectedDepot} onPageChange={onPageChange} page={page} perPage={perPage} update={update} setUpdate={setUpdate}/> :
                        Number(selectedDepot.code) === 12 ? <AgroTable products={categories} total={total} selectedDepot={selectedDepot} onPageChange={onPageChange} page={page} perPage={perPage} update={update} setUpdate={setUpdate}/> :
                            Number(selectedDepot.code) === 14 ? <GardeniaTable products={categories} total={total} selectedDepot={selectedDepot} onPageChange={onPageChange} page={page} perPage={perPage} update={update} setUpdate={setUpdate}/> :
                                <PetTable products={categories} total={total} selectedDepot={selectedDepot} onPageChange={onPageChange} page={page} perPage={perPage} update={update} setUpdate={setUpdate}/>
    return (
        <Card>
            <NewCategoryModal visible={newCategoryModal} setVisible={setNewCategoryModal} category={depots} update={update} setUpdate={setUpdate}/>
            <div className='flex align-items-center justify-content-between mb-3'>
                <h4 className="m-0">Categories || {selectedDepot.name}</h4>
                <div>
                    <Dropdown value={selectedDepot} onChange={(e) => {
                        setSelectedDepot(e.value)
                        setPage(1)
                    }} options={depots}
                              optionLabel="name"
                              placeholder="Select a Depot" className="w-full md:w-14rem mr-2"/>
                    <Button onClick={()=>setNewCategoryModal(true)} label="Create New" icon="pi pi-plus" iconPos="right" />
                </div>
            </div>
            {loading ? <TableSkeleton/> : dataTable}
        </Card>
    );
};

export default Categories;